<div class="login-container">
    <!-- Loading State -->
    @if (isLoading) {
        <mat-card class="login-card">
            <mat-card-header class="login-card-header">
                <mat-card-title>
                    <div class="logo-container">
                        <img class="addboard-logo"
                             [ngSrc]="'../../../assets/img/addboard-logo.svg'"
                             alt="ADDboard Logo"
                             width="96"
                             height="96"
                             priority>
                    </div>
                    <div class="claim-container">
                        <h3 class="claim-text">{{'UC_SLOGAN_1' | translate}} {{'UC_SLOGAN_2' | translate}}</h3>
                    </div>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="loading-message">
                    <mat-spinner diameter="50"></mat-spinner>
                    <p>{{'PAGE_IS_LOADING' | translate}}</p>
                </div>
            </mat-card-content>
        </mat-card>
    }

    <!-- Redirecting to OAuth Provider -->
    @if (isRedirecting) {
        <mat-card class="login-card">
            <mat-card-header class="login-card-header">
                <mat-card-title>
                    <div class="logo-container">
                        <img class="addboard-logo"
                             [ngSrc]="'../../../assets/img/addboard-logo.svg'"
                             alt="ADDboard Logo"
                             width="96"
                             height="96"
                             priority>
                    </div>
                    <div class="claim-container">
                        <h3 class="claim-text">{{'UC_SLOGAN_1' | translate}} {{'UC_SLOGAN_2' | translate}}</h3>
                    </div>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="loading-message">
                    <mat-spinner diameter="50"></mat-spinner>
                    <p>{{'REDIRECTING_TO_LOGIN' | translate}}</p>
                </div>
            </mat-card-content>
        </mat-card>
    }

    <!-- Provider Loading Error (Generic) -->
    @if (hasError) {
        <mat-card class="info-card">
            <mat-card-header class="login-card-header">
                <mat-card-title>
                    <div class="logo-container">
                        <img class="addboard-logo"
                             [ngSrc]="'../../../assets/img/addboard-logo.svg'"
                             alt="ADDboard Logo"
                             width="96"
                             height="96"
                             priority>
                    </div>
                    <div class="claim-container">
                        <h3 class="claim-text">{{'UC_SLOGAN_1' | translate}} {{'UC_SLOGAN_2' | translate}}</h3>
                    </div>
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="info-content">
                    <h3>{{'LOGIN_PROVIDERS_UNAVAILABLE' | translate}}</h3>
                    <p>{{'LOGIN_PROVIDERS_UNAVAILABLE_MESSAGE' | translate}}</p>
                    <button mat-raised-button
                            class="primary"
                            (click)="retryInitialization()">
                        {{'RETRY' | translate}}
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    }

    <!-- Login Options (Ready State) -->
    @if (isReady) {
        <section class="oauth-provider-section">
            <!-- Header -->
            <div class="login-card">
                <div class="section-header-title login-card-header">
                    <div class="logo-container">
                        <img class="addboard-logo"
                             [ngSrc]="'../../../assets/img/addboard-logo.svg'"
                             alt="ADDboard Logo"
                             width="96"
                             height="96"
                             priority>
                    </div>
                    <div class="claim-container">
                        <h3 class="claim-text">{{'UC_SLOGAN_1' | translate}} {{'UC_SLOGAN_2' | translate}}</h3>
                    </div>
                </div>
            </div>

            <!-- Provider Buttons -->
            <div class="login-section">
                @if (showLoggedOutHint) {
                    <p class="logged-out-hint">{{'LOGGED_OUT_HINT' | translate}}</p>
                }
                <div class="provider-buttons">
                    <!-- Local Provider Button -->
                    @if (showLocalProvider && localProvider) {
                        <button mat-raised-button
                                class="oauth-provider-button primary"
                                (click)="loginWithProvider(localProvider)">
                            <span>{{'LOGIN_WITH' | translate}} {{ localProvider.display_name }}</span>
                        </button>
                    }

                    <!-- OAuth Provider Buttons -->
                    @for (provider of activeAuthProviders; track provider._id) {
                        <button mat-raised-button
                                class="oauth-provider-button primary"
                                (click)="loginWithProvider(provider)">
                            <span>{{'LOGIN_WITH' | translate}} {{ provider.display_name }}</span>
                        </button>
                    }

                </div>
            </div>
        </section>
    }
</div>
